export default function BackChevron(props: Readonly<React.SVGAttributes<any>>) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M11 13L6 8L11 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
